import * as v from 'valibot';
import { AvailabilityConfig, StudentName, StudentSettings, StudentSurveyToken, StudentToken, } from '../resources/index.js';
import { api } from './_base.js';
// TokenReadInfo schema
const tokenReadInfoSchema = v.object({
    availabilityConfig: AvailabilityConfig,
    settings: StudentSettings,
    name: StudentName,
    token: StudentToken,
});
export const studentContracts = api({
    'GET /api/surveys/:token': {
        params: { token: StudentSurveyToken },
        input: v.object({}),
        output: tokenReadInfoSchema,
        requiresSession: false,
    },
    'PUT /api/surveys/:token/settings': {
        params: { token: StudentSurveyToken },
        input: StudentSettings,
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: false,
    },
});
//# sourceMappingURL=student.js.map